export enum EEntityType {
  EDelivery = 1,
  ExternalEDelivery = 2,

  NotaParticipant = 3,
  NotaGuest = 4,

  Email = 5,
  CourtPortal = 6,
  ContactMessageSender = 7,

  New = 0,
}
